import {Component, OnInit} from '@angular/core';
import {HttpClient, HttpParams, HttpHeaders} from '@angular/common/http';
import {ActivatedRoute, RouterPreloader, Router, NavigationStart} from '@angular/router';
import {Location} from '@angular/common';
import 'rxjs/add/operator/catch';
import * as $ from 'jquery';
import {HayzinvorXoragir} from './hayzinvorXoragir';
import {Globals} from '../globals';

@Component({
  selector: 'app-hayzinvor-xoragir',
  templateUrl: './hayzinvor-xoragir.component.html',
  styleUrls: ['./hayzinvor-xoragir.component.scss']
})
export class HayzinvorXoragirComponent implements OnInit {
  hayzinvorXoragir: HayzinvorXoragir;
  url;

  p: any = 1;
  collection: any[] = [];
  curent;
  somethingChanged: any;
  dataToSend: any;

  constructor(public router: Router, private http: HttpClient, private route: ActivatedRoute, public globals: Globals, public _router: Router, public _location: Location) {
    var url_string = location.href;
    this.url = url_string;
    this.curent = url_string.substr(url_string.lastIndexOf('/') + 1);
    console.log('***************************************this.curent***********************************');
    console.log(url_string);
  }

  lang = localStorage.getItem('lang') ? localStorage.getItem('lang') : 'hy';

  dateChanged(val: any) {
    var num;
    ;
    this.somethingChanged = val.value.toString().split(' ');
    if (this.somethingChanged[1] == 'Jan') {
      num = '01';
    } else if (this.somethingChanged[1] == 'Feb') {
      num = '02';
    } else if (this.somethingChanged[1] == 'Mar') {
      num = '03';
    } else if (this.somethingChanged[1] == 'Apr') {
      num = '04';
    } else if (this.somethingChanged[1] == 'May') {
      num = '05';
    } else if (this.somethingChanged[1] == 'Jun') {
      num = '06';
    } else if (this.somethingChanged[1] == 'Jul') {
      num = '07';
    } else if (this.somethingChanged[1] == 'Aug') {
      num = '08';
    } else if (this.somethingChanged[1] == 'Sep') {
      num = '09';
    } else if (this.somethingChanged[1] == 'Oct') {
      num = '10';
    } else if (this.somethingChanged[1] == 'Nov') {
      num = '11';
    } else if (this.somethingChanged[1] == 'Dec') {
      num = '12';
    }
    this.dataToSend = this.somethingChanged[3] + '-' + num + '-' + this.somethingChanged[2];
    // console.log(this.dataToSend)
    this.http.get<HayzinvorXoragir>(this.globals.urlMain + 'handes/' + this.curent, {
      params: {
        data: this.dataToSend
      }

    }).subscribe(data => {
      this.hayzinvorXoragir = data;
      this.collection = [];
      var k = Number(data.data.zoratesakner.data.pagination.total);


      for (let i = 0; i <= k; i++) {
        this.collection.push(i);
      }
    });
    $(window).scrollTop(0);
  }

  newsDetalesFalse;

  ngOnInit() {
    $(window).scrollTop(0);
    this.changel();


    setTimeout(() => {
      $('.loaderParent').hide();
      $('li.pagination-next span').html(' ');
      $('li.pagination-next a').html(' ');
      $('li.pagination-previous  span').html(' ');
      $('li.pagination-previous  a').html(' ');
    }, 500);

    this.http.get<HayzinvorXoragir>(this.globals.urlMain + 'handes/' + this.curent).subscribe(data => {
      this.hayzinvorXoragir = data;
      // console.log(this.hayzinvorXoragir)
    }, error => {
      this.newsDetalesFalse = true;
    });

  }

  changeReq() {

    this.http.get<HayzinvorXoragir>(this.globals.urlMain + 'handes/' + this.curent, {
      params: {
        page: this.p,
      }

    }).subscribe(data => {
      this.hayzinvorXoragir = data;
      // console.log(this.slider)
      this.collection = [];
      var k = Number(data.data.zoratesakner.data.pagination.total);


      for (let i = 0; i <= k; i++) {
        this.collection.push(i);
      }
      $(window).scrollTop(0);
    });


  }

  changel() {
    // this.router.navigate(['/hayzinvor/hayzinvor-khoragir/' + this.curent], {queryParams: {page: this.p}});
    // console.log('***************************************this.curent***********************************')
    // console.log(this.curent)
    this.changeReq();
    var height = $('header').height();
    $(window).scrollTop(height);
    this.router.events
      .subscribe((event: NavigationStart) => {
        if (event.navigationTrigger === 'popstate') {
          setTimeout(() => {
            location.reload();
          }, 200);
        }
      });
  }

  openModal(event) {
    $('.modalForVideos').addClass('shown');
    var target = event.target || event.srcElement || event.currentTarget;
    var title = $(target).closest('.iframe').find('.title').text();
    var iframe = $(target).closest('.iframe').find('img').attr('data-id');
    var newIframe = document.createElement('iframe');
    newIframe.src = iframe;
    newIframe.height = '100%';
    newIframe.width = '100%';
    newIframe.allowFullscreen = true;
    $('.modalTitle').html(title);
    $('.modileIframe').html(newIframe);
  }

  closeModal() {
    $('.modileIframe').html('');
    $('.modalDescription').html('');
    $('.modalForVideos').removeClass('shown');
  }
}
